import ModalService from "./ModalService"
import Modal, { ExitModal, FootnotesModal } from "./Modal"
import { Placeholder } from "gatsby-plugin-image"
import { stopScroll } from "../../utils"

const setModalPosition = () => {
  const modalContainer = document.querySelector(".modalContainer")
  const top = window.scrollY
  modalContainer.style.top = `${top}px`
  modalContainer.style.height = `100vh`
}

const createModal = (modalData = {}) => {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth
  ModalService.open(Modal, { ...modalData })
  setModalPosition()
  stopScroll(window.scrollY, scrollbarWidth)
}

export default createModal
